"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var conversions = require("webidl-conversions");
var utils = require("./utils.js");
var HTMLFormElement = require("./HTMLFormElement.js");
var Blob = require("./Blob.js");
var Function = require("./Function.js");
var newObjectInRealm = utils.newObjectInRealm;
var implSymbol = utils.implSymbol;
var ctorRegistrySymbol = utils.ctorRegistrySymbol;
var interfaceName = "FormData";
exports.is = function (value) {
  return utils.isObject(value) && utils.hasOwn(value, implSymbol) && value[implSymbol] instanceof Impl.implementation;
};
exports.isImpl = function (value) {
  return utils.isObject(value) && value instanceof Impl.implementation;
};
exports.convert = function (globalObject, value) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? "The provided value" : _ref$context;
  if (exports.is(value)) {
    return utils.implForWrapper(value);
  }
  throw new globalObject.TypeError("".concat(context, " is not of type 'FormData'."));
};
exports.createDefaultIterator = function (globalObject, target, kind) {
  var ctorRegistry = globalObject[ctorRegistrySymbol];
  var iteratorPrototype = ctorRegistry["FormData Iterator"];
  var iterator = Object.create(iteratorPrototype);
  Object.defineProperty(iterator, utils.iterInternalSymbol, {
    value: {
      target: target,
      kind: kind,
      index: 0
    },
    configurable: true
  });
  return iterator;
};
function makeWrapper(globalObject, newTarget) {
  var proto;
  if (newTarget !== undefined) {
    proto = newTarget.prototype;
  }
  if (!utils.isObject(proto)) {
    proto = globalObject[ctorRegistrySymbol]["FormData"].prototype;
  }
  return Object.create(proto);
}
exports.create = function (globalObject, constructorArgs, privateData) {
  var wrapper = makeWrapper(globalObject);
  return exports.setup(wrapper, globalObject, constructorArgs, privateData);
};
exports.createImpl = function (globalObject, constructorArgs, privateData) {
  var wrapper = exports.create(globalObject, constructorArgs, privateData);
  return utils.implForWrapper(wrapper);
};
exports._internalSetup = function (wrapper, globalObject) {};
exports.setup = function (wrapper, globalObject) {
  var constructorArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var privateData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  privateData.wrapper = wrapper;
  exports._internalSetup(wrapper, globalObject);
  Object.defineProperty(wrapper, implSymbol, {
    value: new Impl.implementation(globalObject, constructorArgs, privateData),
    configurable: true
  });
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;
  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }
  return wrapper;
};
exports["new"] = function (globalObject, newTarget) {
  var wrapper = makeWrapper(globalObject, newTarget);
  exports._internalSetup(wrapper, globalObject);
  Object.defineProperty(wrapper, implSymbol, {
    value: Object.create(Impl.implementation.prototype),
    configurable: true
  });
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;
  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }
  return wrapper[implSymbol];
};
var exposed = new Set(["Window", "Worker"]);
exports.install = function (globalObject, globalNames) {
  var _Object$definePropert;
  if (!globalNames.some(function (globalName) {
    return exposed.has(globalName);
  })) {
    return;
  }
  var ctorRegistry = utils.initCtorRegistry(globalObject);
  var FormData = /*#__PURE__*/function () {
    function FormData() {
      _classCallCheck(this, FormData);
      var args = [];
      {
        var curArg = arguments[0];
        if (curArg !== undefined) {
          curArg = HTMLFormElement.convert(globalObject, curArg, {
            context: "Failed to construct 'FormData': parameter 1"
          });
        }
        args.push(curArg);
      }
      return exports.setup(Object.create((this instanceof FormData ? this.constructor : void 0).prototype), globalObject, args);
    }
    _createClass(FormData, [{
      key: "append",
      value: function append(name, value) {
        var _esValue$implSymbol;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'append' called on an object that is not a valid instance of FormData.");
        }
        if (arguments.length < 2) {
          throw new globalObject.TypeError("Failed to execute 'append' on 'FormData': 2 arguments required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        switch (arguments.length) {
          case 2:
            {
              var curArg = arguments[0];
              curArg = conversions["USVString"](curArg, {
                context: "Failed to execute 'append' on 'FormData': parameter 1",
                globals: globalObject
              });
              args.push(curArg);
            }
            {
              var _curArg = arguments[1];
              if (Blob.is(_curArg)) {
                {
                  var _curArg2 = arguments[1];
                  _curArg2 = Blob.convert(globalObject, _curArg2, {
                    context: "Failed to execute 'append' on 'FormData': parameter 2"
                  });
                  args.push(_curArg2);
                }
              } else {
                {
                  var _curArg3 = arguments[1];
                  _curArg3 = conversions["USVString"](_curArg3, {
                    context: "Failed to execute 'append' on 'FormData': parameter 2",
                    globals: globalObject
                  });
                  args.push(_curArg3);
                }
              }
            }
            break;
          default:
            {
              var _curArg4 = arguments[0];
              _curArg4 = conversions["USVString"](_curArg4, {
                context: "Failed to execute 'append' on 'FormData': parameter 1",
                globals: globalObject
              });
              args.push(_curArg4);
            }
            {
              var _curArg5 = arguments[1];
              _curArg5 = Blob.convert(globalObject, _curArg5, {
                context: "Failed to execute 'append' on 'FormData': parameter 2"
              });
              args.push(_curArg5);
            }
            {
              var _curArg6 = arguments[2];
              if (_curArg6 !== undefined) {
                _curArg6 = conversions["USVString"](_curArg6, {
                  context: "Failed to execute 'append' on 'FormData': parameter 3",
                  globals: globalObject
                });
              }
              args.push(_curArg6);
            }
        }
        return (_esValue$implSymbol = esValue[implSymbol]).append.apply(_esValue$implSymbol, args);
      }
    }, {
      key: "delete",
      value: function _delete(name) {
        var _esValue$implSymbol2;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'delete' called on an object that is not a valid instance of FormData.");
        }
        if (arguments.length < 1) {
          throw new globalObject.TypeError("Failed to execute 'delete' on 'FormData': 1 argument required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        {
          var curArg = arguments[0];
          curArg = conversions["USVString"](curArg, {
            context: "Failed to execute 'delete' on 'FormData': parameter 1",
            globals: globalObject
          });
          args.push(curArg);
        }
        return (_esValue$implSymbol2 = esValue[implSymbol])["delete"].apply(_esValue$implSymbol2, args);
      }
    }, {
      key: "get",
      value: function get(name) {
        var _esValue$implSymbol3;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get' called on an object that is not a valid instance of FormData.");
        }
        if (arguments.length < 1) {
          throw new globalObject.TypeError("Failed to execute 'get' on 'FormData': 1 argument required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        {
          var curArg = arguments[0];
          curArg = conversions["USVString"](curArg, {
            context: "Failed to execute 'get' on 'FormData': parameter 1",
            globals: globalObject
          });
          args.push(curArg);
        }
        return utils.tryWrapperForImpl((_esValue$implSymbol3 = esValue[implSymbol]).get.apply(_esValue$implSymbol3, args));
      }
    }, {
      key: "getAll",
      value: function getAll(name) {
        var _esValue$implSymbol4;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'getAll' called on an object that is not a valid instance of FormData.");
        }
        if (arguments.length < 1) {
          throw new globalObject.TypeError("Failed to execute 'getAll' on 'FormData': 1 argument required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        {
          var curArg = arguments[0];
          curArg = conversions["USVString"](curArg, {
            context: "Failed to execute 'getAll' on 'FormData': parameter 1",
            globals: globalObject
          });
          args.push(curArg);
        }
        return utils.tryWrapperForImpl((_esValue$implSymbol4 = esValue[implSymbol]).getAll.apply(_esValue$implSymbol4, args));
      }
    }, {
      key: "has",
      value: function has(name) {
        var _esValue$implSymbol5;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'has' called on an object that is not a valid instance of FormData.");
        }
        if (arguments.length < 1) {
          throw new globalObject.TypeError("Failed to execute 'has' on 'FormData': 1 argument required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        {
          var curArg = arguments[0];
          curArg = conversions["USVString"](curArg, {
            context: "Failed to execute 'has' on 'FormData': parameter 1",
            globals: globalObject
          });
          args.push(curArg);
        }
        return (_esValue$implSymbol5 = esValue[implSymbol]).has.apply(_esValue$implSymbol5, args);
      }
    }, {
      key: "set",
      value: function set(name, value) {
        var _esValue$implSymbol6;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'set' called on an object that is not a valid instance of FormData.");
        }
        if (arguments.length < 2) {
          throw new globalObject.TypeError("Failed to execute 'set' on 'FormData': 2 arguments required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        switch (arguments.length) {
          case 2:
            {
              var curArg = arguments[0];
              curArg = conversions["USVString"](curArg, {
                context: "Failed to execute 'set' on 'FormData': parameter 1",
                globals: globalObject
              });
              args.push(curArg);
            }
            {
              var _curArg7 = arguments[1];
              if (Blob.is(_curArg7)) {
                {
                  var _curArg8 = arguments[1];
                  _curArg8 = Blob.convert(globalObject, _curArg8, {
                    context: "Failed to execute 'set' on 'FormData': parameter 2"
                  });
                  args.push(_curArg8);
                }
              } else {
                {
                  var _curArg9 = arguments[1];
                  _curArg9 = conversions["USVString"](_curArg9, {
                    context: "Failed to execute 'set' on 'FormData': parameter 2",
                    globals: globalObject
                  });
                  args.push(_curArg9);
                }
              }
            }
            break;
          default:
            {
              var _curArg10 = arguments[0];
              _curArg10 = conversions["USVString"](_curArg10, {
                context: "Failed to execute 'set' on 'FormData': parameter 1",
                globals: globalObject
              });
              args.push(_curArg10);
            }
            {
              var _curArg11 = arguments[1];
              _curArg11 = Blob.convert(globalObject, _curArg11, {
                context: "Failed to execute 'set' on 'FormData': parameter 2"
              });
              args.push(_curArg11);
            }
            {
              var _curArg12 = arguments[2];
              if (_curArg12 !== undefined) {
                _curArg12 = conversions["USVString"](_curArg12, {
                  context: "Failed to execute 'set' on 'FormData': parameter 3",
                  globals: globalObject
                });
              }
              args.push(_curArg12);
            }
        }
        return (_esValue$implSymbol6 = esValue[implSymbol]).set.apply(_esValue$implSymbol6, args);
      }
    }, {
      key: "keys",
      value: function keys() {
        if (!exports.is(this)) {
          throw new globalObject.TypeError("'keys' called on an object that is not a valid instance of FormData.");
        }
        return exports.createDefaultIterator(globalObject, this, "key");
      }
    }, {
      key: "values",
      value: function values() {
        if (!exports.is(this)) {
          throw new globalObject.TypeError("'values' called on an object that is not a valid instance of FormData.");
        }
        return exports.createDefaultIterator(globalObject, this, "value");
      }
    }, {
      key: "entries",
      value: function entries() {
        if (!exports.is(this)) {
          throw new globalObject.TypeError("'entries' called on an object that is not a valid instance of FormData.");
        }
        return exports.createDefaultIterator(globalObject, this, "key+value");
      }
    }, {
      key: "forEach",
      value: function forEach(callback) {
        if (!exports.is(this)) {
          throw new globalObject.TypeError("'forEach' called on an object that is not a valid instance of FormData.");
        }
        if (arguments.length < 1) {
          throw new globalObject.TypeError("Failed to execute 'forEach' on 'iterable': 1 argument required, but only 0 present.");
        }
        callback = Function.convert(globalObject, callback, {
          context: "Failed to execute 'forEach' on 'iterable': The callback provided as parameter 1"
        });
        var thisArg = arguments[1];
        var pairs = Array.from(this[implSymbol]);
        var i = 0;
        while (i < pairs.length) {
          var _pairs$i$map = pairs[i].map(utils.tryWrapperForImpl),
            _pairs$i$map2 = _slicedToArray(_pairs$i$map, 2),
            key = _pairs$i$map2[0],
            value = _pairs$i$map2[1];
          callback.call(thisArg, value, key, this);
          pairs = Array.from(this[implSymbol]);
          i++;
        }
      }
    }]);
    return FormData;
  }();
  Object.defineProperties(FormData.prototype, (_Object$definePropert = {
    append: {
      enumerable: true
    },
    "delete": {
      enumerable: true
    },
    get: {
      enumerable: true
    },
    getAll: {
      enumerable: true
    },
    has: {
      enumerable: true
    },
    set: {
      enumerable: true
    },
    keys: {
      enumerable: true
    },
    values: {
      enumerable: true
    },
    entries: {
      enumerable: true
    },
    forEach: {
      enumerable: true
    }
  }, _defineProperty(_Object$definePropert, Symbol.toStringTag, {
    value: "FormData",
    configurable: true
  }), _defineProperty(_Object$definePropert, Symbol.iterator, {
    value: FormData.prototype.entries,
    configurable: true,
    writable: true
  }), _Object$definePropert));
  ctorRegistry[interfaceName] = FormData;
  ctorRegistry["FormData Iterator"] = Object.create(ctorRegistry["%IteratorPrototype%"], _defineProperty({}, Symbol.toStringTag, {
    configurable: true,
    value: "FormData Iterator"
  }));
  utils.define(ctorRegistry["FormData Iterator"], {
    next: function next() {
      var internal = this && this[utils.iterInternalSymbol];
      if (!internal) {
        throw new globalObject.TypeError("next() called on a value that is not a FormData iterator object");
      }
      var target = internal.target,
        kind = internal.kind,
        index = internal.index;
      var values = Array.from(target[implSymbol]);
      var len = values.length;
      if (index >= len) {
        return newObjectInRealm(globalObject, {
          value: undefined,
          done: true
        });
      }
      var pair = values[index];
      internal.index = index + 1;
      return newObjectInRealm(globalObject, utils.iteratorResult(pair.map(utils.tryWrapperForImpl), kind));
    }
  });
  Object.defineProperty(globalObject, interfaceName, {
    configurable: true,
    writable: true,
    value: FormData
  });
};
var Impl = require("../xhr/FormData-impl.js");